import { RunStateTransition } from "types/generated";
import UnfinishedRunActions from "components/Run/elements/UnfinishedRunActions";

import DiscardedEntry from "../entries/DiscardedEntry";
import { RunEntryContext } from "../types";
import { getRunStateTransitionId } from "./getRunStateTransitionId";

export const createDiscardedEntry = (
  { timestamp, note, username, stateVersion }: RunStateTransition,
  {
    stackId,
    runId,
    canRetry,
    runRetryBlocker,
    isTaskRun,
    isModuleRun,
    runTaskCommand,
    canPerformAgain,
  }: RunEntryContext
) => (
  <DiscardedEntry
    key={getRunStateTransitionId(timestamp, stateVersion)}
    timestamp={timestamp}
    note={note}
    username={username}
  >
    <UnfinishedRunActions
      stackId={stackId}
      runId={runId}
      canRetry={canRetry}
      runRetryBlocker={runRetryBlocker}
      isTaskRun={isTaskRun}
      isModuleRun={isModuleRun}
      canPerformAgain={canPerformAgain}
      runTaskCommand={runTaskCommand}
    />
  </DiscardedEntry>
);
